import { ReconnectButton } from './ReconnectButton';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Keep component for backward compatibility
 */
/**
 * @deprecated
 */
export const CtaReconnectButton = props => {
  return /*#__PURE__*/_jsx(ReconnectButton, Object.assign({}, props));
};